import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import './Announcements.css';

const Announcements: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [iframeWidth, setIframeWidth] = useState<number | null>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const updateWidth = () => {
      const width = container.offsetWidth;
      if (width > 0) {
        setIframeWidth(width);
      }
    };

    // Initial measurement
    updateWidth();

    // Use ResizeObserver to watch for container size changes
    const resizeObserver = new ResizeObserver(() => {
      updateWidth();
    });

    resizeObserver.observe(container);

    // Fallback: also listen to window resize
    window.addEventListener('resize', updateWidth);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const facebookPageUrl = iframeWidth
    ? `https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FGener8ionsChurch&tabs=timeline&width=${iframeWidth}&height=800&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`
    : '';

  return (
    <div className="announcements-page">
      <div className="announcements-hero">
        <motion.div
          className="announcements-hero-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1>Announcements & Updates</h1>
          <p>Stay connected with the latest news and events from Gener8ions Church</p>
        </motion.div>
      </div>

      <div className="announcements-container">
        <motion.div
          className="announcements-content"
          initial="initial"
          whileInView="animate"
          viewport={{ once: true, margin: "-100px" }}
          variants={{
            animate: {
              transition: {
                staggerChildren: 0.1
              }
            }
          }}
        >
          <motion.div className="facebook-section" variants={fadeInUp}>
            <h2>Follow Us on Facebook</h2>
            <p className="section-intro">
              Get the latest updates, event announcements, and community news directly from our Facebook page.
            </p>
            <div className="facebook-embed-container" ref={containerRef}>
              {iframeWidth && (
                <iframe
                  key={iframeWidth}
                  src={facebookPageUrl}
                  scrolling="no"
                  frameBorder="0"
                  allowFullScreen={true}
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  title="Gener8ions Church Facebook Page"
                  className="facebook-iframe"
                ></iframe>
              )}
            </div>
            <div className="facebook-link-section">
              <p>Can't see the feed? <a href="https://www.facebook.com/Gener8ionsChurch" target="_blank" rel="noopener noreferrer">Visit our Facebook page</a></p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Announcements;

